import html2canvas from 'html2canvas';

const fmt = (n) => (n != null ? Number(n).toLocaleString('ko-KR') : '0');

function esc(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function rowHtml(record) {
  return `
    <tr>
      <td class="name">${esc(record.user_name)}</td>
      <td class="money incentive">${fmt(record.incentive_amount)}</td>
      <td class="money allowance">${fmt(record.unused_annual_leave_allowance)}</td>
      <td class="money deduction">${fmt(record.attendance_deduction_amount)}</td>
      <td class="money deduction">${fmt(record.weekly_holiday_deduction)}</td>
      <td class="memo">${esc(record.monthly_memo || '')}</td>
    </tr>
  `;
}

export async function downloadTaxOfficeSubmissionImage({
  period,
  records,
  companyName,
}) {
  if (!period || !records?.length) {
    window.alert('월종합으로 내보낼 급여 데이터가 없습니다.');
    return;
  }

  const monthText = `${period.year}년 ${period.month}월`;
  const title = `${monthText} 급여 월종합`;
  const root = document.createElement('div');
  root.style.position = 'fixed';
  root.style.left = '-10000px';
  root.style.top = '0';
  root.style.width = '1180px';
  root.style.background = '#ffffff';
  root.style.color = '#111827';
  root.style.fontFamily = "'Malgun Gothic','Apple SD Gothic Neo',sans-serif";
  root.innerHTML = `
    <style>
      .tax-export{width:1180px;min-height:420px;background:#fff;color:#111827;padding:34px 38px 36px}
      .tax-export *{box-sizing:border-box}
      .topline{height:7px;width:100%;background:#172033;border-radius:999px;margin-bottom:24px}
      .head{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:24px}
      .kicker{font-size:12px;font-weight:800;color:#64748b;letter-spacing:.18em;text-transform:uppercase;margin-bottom:9px}
      h1{margin:0;font-size:32px;font-weight:800;line-height:1.12;letter-spacing:0;color:#101828}
      .meta{display:grid;gap:5px;text-align:right;font-size:13px;font-weight:600;color:#667085;line-height:1.35}
      .meta strong{color:#344054;font-weight:800}
      table{width:100%;border-collapse:collapse;table-layout:fixed;border:1px solid #d0d5dd;border-radius:8px;overflow:hidden}
      thead th{height:38px;padding:9px 12px;background:#172033;color:#fff;font-size:14px;font-weight:800;text-align:center;border-right:1px solid rgba(255,255,255,.16)}
      thead th:last-child{border-right:0}
      tbody td{min-height:34px;padding:8px 12px;border-right:1px solid #e4e7ec;border-bottom:1px solid #e4e7ec;background:#fff;font-size:15px;font-weight:500;line-height:1.28;color:#101828;vertical-align:middle}
      tbody tr:nth-child(even) td{background:#f8fafc}
      tbody tr:last-child td{border-bottom:0}
      tbody td:last-child{border-right:0}
      .name{text-align:center;font-weight:650;color:#101828}
      .money{text-align:right;font-variant-numeric:tabular-nums;white-space:nowrap;font-weight:650}
      .incentive{color:#245f9f}
      .allowance{color:#2f6f62}
      .deduction{color:#9f423f}
      .memo{text-align:left;white-space:pre-wrap;overflow:visible;text-overflow:clip;color:#475467;font-weight:500;line-height:1.45;vertical-align:top;word-break:keep-all;overflow-wrap:anywhere}
    </style>
    <section class="tax-export">
      <div class="topline"></div>
      <div class="head">
        <div>
          <div class="kicker">Payroll Summary</div>
          <h1>${esc(title)}</h1>
        </div>
        <div class="meta">
          <div><strong>${esc(companyName || period.company_code || '')}</strong></div>
          <div>대상 인원 ${records.length}명</div>
          <div>기준월 ${esc(monthText)}</div>
        </div>
      </div>
      <table>
        <colgroup>
          <col style="width:145px" />
          <col style="width:165px" />
          <col style="width:165px" />
          <col style="width:165px" />
          <col style="width:165px" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th>이름</th>
            <th>인센티브</th>
            <th>미사용연차수당</th>
            <th>근태공제</th>
            <th>주휴공제</th>
            <th>비고</th>
          </tr>
        </thead>
        <tbody>${records.map(rowHtml).join('')}</tbody>
      </table>
    </section>
  `;

  document.body.appendChild(root);
  try {
    if (document.fonts?.ready) await document.fonts.ready;
    const canvas = await html2canvas(root.querySelector('.tax-export'), {
      backgroundColor: '#ffffff',
      scale: 1,
      useCORS: true,
    });
    const link = document.createElement('a');
    link.href = canvas.toDataURL('image/png');
    link.download = `월종합_${period.company_code || 'PINE'}_${period.year}-${String(period.month).padStart(2, '0')}.png`;
    link.click();
  } finally {
    root.remove();
  }
}
